import lodash from "lodash";
import { createSelector } from "reselect";
import { CALL_API } from "./constants";

export const getScopedState = (state) => {
	return state[CALL_API];
};

export const getTypeState = (typeName) =>
	createSelector(
		[getScopedState],
		(state) => {
			return state && state[typeName] ? state[typeName] : {};
		}
	);

export const isLoading = (typeName) =>
	createSelector(
		[getTypeState(typeName)],
		(state) => {
			return state ? state.isLoading : true;
		}
	);

export const isSuccess = (typeName) =>
	createSelector(
		[getTypeState(typeName)],
		(state) => {
			return state ? state.isSuccess : null;
		}
	);

export const getErrors = createSelector(
	[getScopedState],
	(state) => {
		const errors = [];
		lodash.forOwn(state, (value) => {
			value && value.responseCodeMessage && errors.push(value.responseCodeMessage);
		});
		return errors;
	}
);

export const getAction = (action) =>
	createSelector(
		[getScopedState],
		(scopedState) => (scopedState[action] ? scopedState[action] : null)
	);
